import { Post, Get } from '@/utils/axios'

/**
 * notice 列表
 * @param {*} data
 * @returns
 */
export function getPageNotice(data) {
  return Post('/Notice/getPageNotice', data)
}
/**
 * notice 未读列表
 * @param {*} data
 * @returns
 */
export function GetUnreadNotice(data) {
  return Post('/Notice/GetUnread', data)
}

/**
 * notice 详情
 * @param {*} id
 * @returns
 */
export function getNotice(id) {
  return Get(`/Notice/${id}`)
}

/**
 * notice 已读
 * @param {*} id
 * @returns
 */
export function readNotice(id) {
  return Post(`/Notice/readNotice`, { id })
}

